"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
const Twitter = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    stroke = 'currentColor',
    strokeWidth = '2',
    strokeLinecap = 'round',
    strokeLinejoin = 'round',
    fill = "none",
    size = '24',
    viewBox = '0 0 30 30',
    style = {
      transform: 'scale(1.5)'
    },
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: viewBox,
    fill: fill,
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    style: style
  }, rest), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-5.031 -32)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.166,7.852h0l-.514-.775L1.56.909H3.321l3.3,4.977.514.775,4.293,6.47H9.669ZM11.43,0l-4.2,5.147L3.871,0H0L5.075,7.784,0,14H1.147L5.585,8.565,9.129,14H13L7.736,5.927,12.577,0Z",
    transform: "translate(14.031 40)",
    strokeWidth: "0"
  })));
});
var _default = exports.default = Twitter;